import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "src/components/dialogue/radix-dialog";
import { useState } from "react";
import { useGalleryImages } from "../../hooks/gallery/useFetchGalleryImages";
import { GalleryImage } from "../../types/galleryImage";
import { IMAGE_CDN } from "src/redux/api/appConst";

const ImageGalleryModal = ({
  children,
  selectImage,
}: {
  children: React.ReactNode;
  selectImage: (image: string) => void;
}) => {
  const [open, setOpen] = useState(false);
  const { data: galleryImages = [] as GalleryImage[] } = useGalleryImages();

  const handleSelectedImage = (image: string) => {
    selectImage(image);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className="">{children}</DialogTrigger>
      <DialogContent className="border-transparent max-h-[75vh] max-w-5xl bg-white border border-gray-300">
        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50">
          <h3 className="text-xl font-bold">Pick Image</h3>
        </div>
        <div className="p-6 grid grid-cols-4 gap-4 w-full">
          {Array.isArray(galleryImages) &&
            galleryImages.map((img: GalleryImage) => (
              <div>
                <img
                  key={img.photo_id}
                  src={`${IMAGE_CDN}/${img.s3_key}`}
                  className=" object-cover size-52 group aspect-square rounded-2xl overflow-hidden border-2 border-transparent hover:border-emerald-500 transition-all cursor-pointer"
                  alt="Asset"
                  onClick={() => handleSelectedImage(img.s3_key)}
                />
                <p className="text-sm text-emerald-600">{img.description}</p>
              </div>
            ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageGalleryModal;
